import callApiAxiosClient from '../../axios/axios_client';

function deleteCategoryPicture(picture: string): Promise<number> {
  const token = JSON.parse(localStorage.getItem('user')!);
  const authorization = 'Bearer ' + token.token;
  return callApiAxiosClient<number>({
    method: 'post',
    url: 'categories/delete-pictures',
    headers: {
      'Content-Type': 'Application/json',
      Authorization: authorization,
    },
    data: {
      picture: picture,
    },
  });
}
export default deleteCategoryPicture;
